const PATIENT_PAGE_PATH = /^\/patients\/([^/]+)\/?$/;

export function patientIdFromPagePath(pathname: string): string | null {
    return PATIENT_PAGE_PATH.exec(pathname)?.[1] ?? null;
}
